import { useListItemDataProvider } from "@circle-react-shared/uikit/SortableList";

import { SidebarItem } from "../SidebarItem";
import { useSidebarCompassThemeVars } from "../useSidebarCompassThemeVars";
import type { SidebarLink } from "./LinkItem";

export const LinkItemDragOverlay = () => {
  const { item: link } = useListItemDataProvider() as { item: SidebarLink };
  const sidebarThemeVars = useSidebarCompassThemeVars();

  return (
    <div style={sidebarThemeVars}>
      <SidebarItem rootElement={<div />}>
        <SidebarItem.Content label={link.name} startIcon="arrow-up-right" />
      </SidebarItem>
    </div>
  );
};
